

const state = {
  query: {
    cardNo: '',
    startDate: '',
    endDate: '',
    invoiceList: [],
    backive: '',
    backiveDown: '',
    selectOrderId: '',
    voucherList: [],
    useVoucherList: [],
    rebateAmount: '',
    refundMoney: '',
    cashValue: ''
  },
  voucherList: [],
  invoiceList: [],
  useVoucherList: [],
  queryHistory: {
    cardNo: '',
    pageNo: '',
    startDate: '',
    endDate: '',
  },
  list: [],
  result: {
    orderMoney: '', //订单金额
    returnAmt: '', //实际退款金额
    revAmount: '', //优惠不可退金额
    crmAmount: '', //券不可退扣减本金额
    status: ''
  }
}

const mutations = {
  SET_DATA(state, obj) {
    state.query.cardNo = obj.cardNo
    state.query.startDate = obj.startDate
    state.query.endDate = obj.endDate
  },
  SET_HISTORYQUERY(state, obj) {
    state.queryHistory.cardNo = obj.cardNo
    state.queryHistory.startDate = obj.startDate
    state.queryHistory.endDate = obj.endDate
    state.queryHistory.pageNo = obj.pageNo
  },
  SET_LIST(state, data) {
    state.list = data
  },
  SET_INVOICElIST(state, data) {
    state.invoiceList = data.invoiceList
    state.backive = data.backive
  },
  SET_ORDERID(state, data) {
    state.query.selectOrderId = data.orderId
  },
  SET_VOUCHERLIST(state, data) {
    state.voucherList = data.voucherList
    state.rebateAmount = data.rebateAmount
  },
  SET_USEVOUCHERLIST(state, data) {
    state.useVoucherList = data.useVoucherList
  },
  SET_HISTORYLIST(state, data) {
    state.historyList = data.historyList
  },
  SET_MONEYS(state, data) {
    state.query.cashValue = data.cashValue
    state.query.rebateAmount = data.rebateAmount
    state.query.refundMoney = data.refundMoney
    state.query.backive = data.backive
    state.query.backiveDown = data.backiveDown
  },
  SET_RESULT(state, data) {
    console.log(data)
    state.result.orderMoney = data.order.orderMoney
    state.result.returnAmt = data.order.returnAmt
    state.result.revAmount = data.order.revAmount
    state.result.crmAmount = data.order.crmAmount
    state.result.status = data.result
  },
  // SET_PHOTO5(state, { photo5 }) {
  //   state.photo5 = photo5
  // },
  CLEAR(state) {
    state.cardNo = ''
    state.startDate = ''
    state.endDate = ''
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
